import { type AnyObject } from '@Types';
import { useEventLogger } from 'FrontRoyalAngular';
import { useEffect } from 'react';
import { type BotUiContext } from 'TutorBotConversation';
import { getLogInfo } from '../utils/getLogInfo';

export function useLogLaunchEvent({
    eventType,
    agentIdentifier,
    uiContext,
    extraTokenAttributes,
}: {
    eventType: string;
    agentIdentifier: string;
    uiContext: BotUiContext;
    extraTokenAttributes?: AnyObject;
}) {
    const EventLogger = useEventLogger();

    useEffect(() => {
        EventLogger.log(eventType, getLogInfo({ uiContext, agentIdentifier, extraTokenAttributes }));
    }, [EventLogger, eventType, agentIdentifier, extraTokenAttributes, uiContext]);
}
